import { gql, useQuery } from "@apollo/client";
import { auth } from "firebase";
import React from "react";

export const GET_CASH_BALANCE_BY_PK = gql`
  query getCashByPk($id: String!) {
    users_by_pk(id: $id) {
      id
      cash_balance
      user_country {
        currency
      }
    }
  }
`;

const CashBalance = () => {
  const { data, loading, error } = useQuery(GET_CASH_BALANCE_BY_PK, {
    variables: {
      id: auth().currentUser?.uid,
    },
  });

  if (!loading && data) {
    return (
      <p>
        {data.users_by_pk.user_country.currency +
          " " +
          data.users_by_pk.cash_balance || 0}
      </p>
    );
  }

  if (error) {
    return <p>Error! Try refresh!</p>;
  }

  return <p>Loading...</p>;
};

export default CashBalance;
